import { inject, Injectable } from '@angular/core';
import { docData } from '@angular/fire/firestore';
import { doc, DocumentReference, getFirestore } from 'firebase/firestore';
import { AppUser, DbCollection, DbDocsService, DbDocument } from 'moddy/common';
import { filter, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppUsersRepository {
    private readonly dbDocsService = inject(DbDocsService);

    private readonly collectionPath = DbCollection.Root.Users;

    public async get(id: string): Promise<DbDocument<AppUser> | null> {
        const snapshot = await this.dbDocsService.read<AppUser>(`${this.collectionPath}/${id}`);

        return snapshot?.exists() ? new DbDocument(id, snapshot.data()) : null;
    }

    public async getRef(id: string): Promise<DocumentReference<AppUser> | null> {
        const snapshot = await this.dbDocsService.read<AppUser>(`${this.collectionPath}/${id}`);

        return snapshot ? snapshot.ref : null;
    }

    public observe(id: string): Observable<DbDocument<AppUser>> {
        const docRef = doc(getFirestore(), `${this.collectionPath}/${id}`);
        const data$ = docData(docRef, { idField: '_id' });

        return data$.pipe(
            filter(Boolean),
            map((data) => new DbDocument(data!._id, data as AppUser))
        );
    }
}
